import React from 'react';

interface ISearchResultCardProps<T> {
    item: T;
    isSelected?: boolean;
    onSelected?: (item: T) => void;
}

const SearchResultCard: React.FC<ISearchResultCardProps<Object>> = (props) => {
    const style1: React.CSSProperties = {
        display: 'inline-block',
        width: '7%',
        visibility: 'visible',
    };

    const style2: React.CSSProperties = {
        display: 'inline-block',
        width: '0',
        visibility: 'collapse',
    };

    let icon1 = style1;
    let icon2 = style2;
    let className = `dlc-card`;
    if (props.isSelected) {
        className += ' active';
        icon1 = style2;
        icon2 = style1;
    }

    const onSelect = props.onSelected ? () => props.onSelected(props.item) : undefined;

    return (
        <div className={className} style={{ margin: '1.3rem 0', padding: '1rem' }} onClick={onSelect}>
            <span style={icon1}>
                <i style={{ color: '#6393C1', fontSize: '1.5em' }} className={`far fa-square`} />
            </span>
            <span style={icon2}>
                <i style={{ color: '#6393C1', fontSize: '1.5em' }} className={`far fa-check-square`} />
            </span>
            <span style={{ width: '93%' }}>{props.children}</span>
        </div>
    );
};

export default SearchResultCard;



// WEBPACK FOOTER //
// ./src/components/project/sections/tract/components/SearchResultCard.tsx